<script>
import Radio from "@/pages/components/form/horizontal/radio.vue";
import formInput from "@wielink-application/shared/js/mixins/formInput";

export default {
  mixins: [formInput],
  components: {Radio},
  props: {
    label: {
      type: String
    }
  }
}
</script>

<template>
  <div class="d-flex gap-3">
    <Radio @update:modelValue="$emit('update:modelValue', $event)" v-model="modelValue" :form="form" :name="name" :id="`${this.renderedId}-1`" value="1" label="Ja"/>
    <Radio @update:modelValue="$emit('update:modelValue', $event)" v-model="modelValue" :form="form" :name="name" :id="`${this.renderedId}-2`" value="0" label="Nee"/>
  </div>
</template>